
const regexChat = {
  html: /<a data-user-id="(.*?)" class="cursor-pointer mentioned-user.*?" id="user-mention-id-.*?">@(.*?)<\/a>/g,
  mention: /@\[([^\]]+)\]/g,
  mentionRaw: /\[([^\]]+)\]/
}

function renderShortcode (message) {
  return message.replace(/<div>/g, '\n').replace(/<\/div>/g, '').replace(regexChat.html, '@[$1|$2]')
}

function renderMention (message, asText = false) {
  return message.replace(regexChat.mention, function (mention) {
    const mentionRaw = mention.match(regexChat.mentionRaw)[1]
    const userMeta = mentionRaw.split('|')
    const renderHTML = `<a data-user-id="${userMeta[0]}" id="user-mention-id-${userMeta[0]}" class="cursor-pointer mentioned-user user-mention-id-${userMeta[0]}" onclick="document.getElementById('user-id-${userMeta[0]}').scrollIntoView({behavior: 'smooth'})">@${userMeta[1]}</a>`
    return asText ? `@${userMeta[1]}` : renderHTML
  })
}

function isContainMention (message, userId) {
  const mentionRaw = message.match(regexChat.mention)
  if (mentionRaw) {
    const userMeta = mentionRaw[0].match(regexChat.mentionRaw)[1].split('|')
    return parseInt(userMeta[0]) === parseInt(userId)
  }
  return false
}

export { renderShortcode, renderMention, isContainMention }
